module.exports = require("os-locale");